@import 'styles/mixins';
@import 'styles/variables';

$headerPadding: 16px;
$toggleSize: 22px;

.header {
  display: flex;
  align-items: flex-start;
  padding: $headerPadding;
  column-gap: 4px;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: 2px;
    bottom: 0;
    top: $toggleSize + $headerPadding;
    left: calc($headerPadding + ($toggleSize / 2) - 1px);
    background-color: $grey-5;
  }

  &.highlighted:after {
    background-color: $grey-10;
  }

  &.collapsed:after {
    display: none;
  }

  &:focus {
    outline: 0;
  }
}

.toggle {
  background: $grey-5;
  border-radius: 50%;
  height: $toggleSize;
  width: $toggleSize;
  color: $green-60;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 200ms ease-in-out;

  svg {
    fill: $grey-30;
  }

  .highlighted & {
    background: $grey-10;
  }

  .collapsed > & {
    transform: rotate(-90deg);
  }
}

.title {
  color: $grey-90;
  @include md-regular;
  flex: 1;
}

.titleInput {
  border: 1px solid $green-50;
  border-radius: 4px;
  padding: 0 6px;
  line-height: 26px;
  margin-top: -4px;
  width: 100%;

  &:focus {
    box-shadow: 0 0 0 3px rgba(0, 163, 158, 0.11);
  }
}

.content {
  // Pull the content up to balance out the bottom padding
  margin-top: calc($headerPadding * -1);
}
